import { PlayerMedicalExaminationFilters } from '@/interfaces/filters/playerMedicalExaminationFilters';
import { ListResponse } from '@/interfaces/list';
import { MedicalExamination } from '@/interfaces/medicalExamination';
import { MedicalExaminationResource, medicalExaminationResource } from '@/resources/medicalExamination.resource';
import { EntityModule } from '../../entity.module';

/**
 * Moduł badań lekarskich zawodnika
 *
 * @export
 * @class PlayerMedicalExaminationModule
 * @extends {EntityModule<MedicalExamination, MedicalExaminationResource>}
 */
export class PlayerMedicalExaminationModule extends EntityModule<MedicalExamination, MedicalExaminationResource> {
  constructor() {
    super(medicalExaminationResource);
    this.actions = {
      ...this.actions,

      /**
       * Lista badań lekarskich zawodnika
       *
       * @param {*} context
       * @param {PlayerMedicalExaminationFilters} filters
       * @returns {Promise<void>}
       */
      list: (context: any, filters: PlayerMedicalExaminationFilters): Promise<void> => {
        filters.teamId = context.rootState.team.id;
        filters.profileId = context.rootState.team.player.id;
        return this.resource
          .playerMedicalExaminationList(filters)
          .then(({ list, count }: ListResponse<MedicalExamination>) => {
            context.commit('saveList', list);
            context.commit('saveCount', count);
          });
      }
    };
  }
}

export default new PlayerMedicalExaminationModule();
